'use strict';

export default class Slide {

    constructor(slideDom) {
        this._slideDom = slideDom;
        this._urlPath = slideDom.querySelector("a").getAttribute("href");
        this._promoType = slideDom.querySelector("a").getAttribute("data-promo-type");
        this._hasLever = slideDom.querySelectorAll(".promo_shoppromo-large--lever-tag").length > 0;
        this._featureLabels = JSON.parse(slideDom.getAttribute('data-feature-labels'));
        if (this._hasLever) {
            this._leverTrackingPayload = JSON.parse(slideDom.querySelector(".promo_shoppromo-large--lever-tag").getAttribute("data-tracking-payload"));
        }
    }

    getUrlPath() {
        return this._urlPath;
    }

    getPromoType() {
        return this._promoType;
    }

    setIsTracked() {
        this._slideDom.setAttribute("data-slidetracked", 'true');
    }

    isTracked() {
        this._slideDom.getAttribute("data-slidetracked");
    }

    hasLever() {
        return this._hasLever;
    }

    getLeverTrackingPayload() {
        return this._leverTrackingPayload;
    }

    getFeatureLabels() {
        return this._featureLabels;
    }
}